import { 
  LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
  ClipboardList, Scale, IndianRupee, BarChart3, 
  UserCog, FileText, ClipboardCheck, Headset, Wallet, 
  FileBadge, FileQuestion, ReceiptIndianRupee, KeySquare,
  BadgeCheck,  
  Briefcase,    
  FolderKanban, 
  PackageCheck, 
  PieChart,     
  Target,       
  ChartLine,
  FileSignature,
  UserCircle,   
  FileSpreadsheet, 
  ClipboardType,  
  Layers,         
  UsersRound,
  MapIcon,
  IndianRupeeIcon,
  LucideIdCardLanyard,
  PowerCircle,
  Logs,
  Activity,
  BookTemplate,
  User2Icon,
  UserCircle2,     
} from "lucide-react";

const navBarData = [
  // SUPER DASHBOARD
  { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] },
  // { id: "overview", label: "Lead Overview", icon: LayoutDashboard, path: "/overview", roles: [1] },

  // MAIN DASHBOARD
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] },

      {
      id: "master",
      label: "Master",
      icon: Layers,
      roles: [1],
      children: [
        { id: "categories", label: "Category", path: "/categories", icon: Layers },
        { id: "brands", label: "Brand", path: "/brands", icon: Layers },
        { id: "devicemodal", label: "Device Models", path: "/devicemodal", icon: Layers },
        { id: "products", label: "Products", path: "/products", icon: Layers },
        { id: "pricetemplate", label: "Price Templates", path: "/pricetemplate", icon: BookTemplate },
        { id: "badgepackage", label: "Badges & Packages", path: "/badgepackage", icon: BadgeCheck },
      ]
    },

    // {
    //   id: "partner",
    //   label: "Partner",
    //   icon: Layers,
    //   roles: [1],
    //   path: "/partners",
    //   children: [
    //     { id: "amdcomp", label: "Master Channel Partner (MCP)", path: "/amdcomp", icon: UsersRound, },
    //     { id: "admagents", label: "Channel Partner (CP)", path: "/admagents", icon: UsersRound, },
    //     { id: "admretailers", label: "Retailers", path: "/admretailers", icon: Store },
    //     { id: "admretuser", label: "ARP Users", path: "/admretuser", icon: UserCog },
    //     { id: "customerlist", label: "Customer List", path: "/customerlist", icon: ClipboardList },
    //   ]
    // },

    { id: "partner", label: "Partners", icon: User2Icon, path: "/partners", roles: [1] },
    {
      id: "transactions",
      label: "Invoices & Payments",
      icon: IndianRupee,
      roles: [1],
      children: [
        { id: "keys", label: "Payment ID's", path: "/keys", icon: KeySquare, },
        { id: "paymentlist", label: "Payment List", path: "/paymentlist", icon: IndianRupeeIcon },
        { id: "retinv", label: "Invoices & Payment", path: "/retinv", icon: ReceiptIndianRupee },
      ]
    },
    {
      id: "commandearnings",
      label: "Commissions & Earnings",
      icon: IndianRupee,
      roles: [1],
      children: [
        { id: "earnings", label: "Earnings", path: "/earnings", icon: ChartLine, },
        { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
      ]
    },

  // ADMIN DASHBOARD
  // { id: "amdcomp", label: "Master Channel Partner (MCP)", icon: UsersRound, path: "/amdcomp", roles: [2] },
  { id: "admagents", label: "Channel Partner (CP)", icon: UsersRound, path: "/admagents", roles: [2] },
  
  { id: "allemployees", label: "Employees", icon: UserPlus, path: "/allemployees", roles:[2] },
  // { id: "admretailers", label: "Retailers", icon: Store, path: "/admretailers", roles: [1] },
  // { id: "keys", label: "Payment ID's", icon: KeySquare, path: "/keys", roles: [1] },
  { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1] },
  // { id: "admcomsn", label: "Commissions & Payouts", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [1] },
  // { id: "admtask", label: "Tasks & Work", icon: ClipboardType, path: "/admtask", roles: [1,2] },
  { id: "admlegal", label: "Legal & Compliance", icon: FileSignature, path: "/admlegal", roles: [1,2] },
  // { id: "admretuser", label: "ARP Users", icon: UserCog, path: "/admretuser", roles: [1] },
  // { id: "admanltc", label: "Analytics & Targets", icon: ChartLine, path: "/admanltc", roles: [1,2] },
  // { id: "devicemodal", label: "Device Model", icon: PackageCheck, path: "/devicemodal", roles: [1] },
  { id: "assignmap", label: "Assign Map", icon: MapIcon, path: "/assignmap", roles: [1] },
  { id: "subret", label: "Subscription Users", icon: MapIcon, path: "/sub-ret", roles: [1,2] },
  // { id: "paymentlist", label: "Payment List", icon: IndianRupeeIcon, path: "/paymentlist", roles: [1] },
  
  // { id: "payment-details", label: "Payment List", icon: IndianRupeeIcon, path: "/company/payment-details/:paymentId", roles: [1,2] },

  // EMPLOYEE DASHBOARD
  { id: "empdash", label: "Dashboard", icon: Briefcase, path: "/empdashboard", roles: [1,2,3,4] },
  { id: "teammember", label: "Team Members", icon: Users, path: "/teammember", roles: [1,3] },
  // { id: "badgepackage", label: "Badges & Packages", icon: BadgeCheck, path: "/badgepackage", roles: [1] },

  // OPERATION DASHBOARD
  { id: "oprdash", label: "Dashboard", icon: FolderKanban, path: "/oprdashboard", roles: [3] },
  { id: "oprret", label: "Users", icon: Store, path: "/oprretail", roles: [3] },
  // { id: "retrem", label: "Reminders", icon: Store, path: "/ret-reminder", roles: [3] },

  // { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
  { id: "oprreports", label: "Reports", icon: FileSpreadsheet, path: "/oprreports", roles: [3] },

  // AGENT DASHBOARD
  { id: "agentdashboard", label: "Dashboard", icon: Layers, path: "/agentdashboard", roles: [4] },
  { id: "agentretailers", label: "ARP & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
    { id: "stepsprogress", label: "Step Progress", icon: Store, path: "/stepsprogress", roles: [1,2,3,4] },
  // { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

  // RETAILER DASHBOARD
  { id: "retailerdashboard", label: "Home", icon: PieChart, path: "/retailerdashboard", roles: [5] },
  { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5,6] },
  { id: "customerlist", label: "Customer List", icon: ClipboardList, path: "/customerlist", roles: [5,6] },
  { id: "earnings", label: "Earnings", icon: ChartLine, path: "/earnings", roles: [2,4,5,6] },
  { id: "admcomsn", label: "Commissions", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [2,4,6] },
  { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5] },
  { id: "retproduct", label: "Subscription Products", icon: LucideIdCardLanyard, path: "/retproduct", roles: [5] },
  { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,4,5] },
  // { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
  { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
  { id: "activation-report", label: "Activation Reports", icon: Activity, path: "/activation-report", roles: [1,3,2] },
  { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },
 
  // USER DASHBOARD
  { id: "userdashboard", label: "Dashboard", icon: Target, path: "/userdashboard", roles: [6] },
  // { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
  // { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
  { id: "userprofile", label: "Profile", icon: UserCircle, path: "/userprofile", roles: [6] },

  // CUSTOMER DASHBOARD
  { id: "custdashboard", label: "Dashboard", icon: PieChart, path: "/custdashboard", roles: [7] },
  { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [7] },
  { id: "custclaims", label: "Claims", icon: ClipboardCheck, path: "/custclaims", roles: [7] },
  { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [7] },
  { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [7] },

  { id: "report-logs", label: "Message Logs", icon: Logs, path: "/report-logs", roles: [1] },
  { id: "syncdevice", label: "sync device", icon: UserCircle2, path: "/syncdevice", roles: [1] },
  // { id: "profile", abel: "Profile", icon: UserCircle2, path: "/profile", roles: [5] },
  
];

export default navBarData;


// *******************************************code without agent change*************************************

// import { 
//   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
//   ClipboardList, Scale, IndianRupee, BarChart3, 
//   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
//   FileBadge, FileQuestion, ReceiptIndianRupee, KeySquare,
//   BadgeCheck,  
//   Briefcase,    
//   FolderKanban, 
//   PackageCheck, 
//   PieChart,     
//   Target,       
//   ChartLine,
//   FileSignature,
//   UserCircle,   
//   FileSpreadsheet, 
//   ClipboardType,  
//   Layers,         
//   UsersRound,
//   MapIcon,
//   IndianRupeeIcon,
//   LucideIdCardLanyard,
//   PowerCircle,
//   Logs,
//   Activity,
//   BookTemplate,
//   User2Icon,
//   KeyRound,
//   Package,     
// } from "lucide-react";

// const navBarData = [
//   // SUPER DASHBOARD
//   { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] },
//   // { id: "overview", label: "Lead Overview", icon: LayoutDashboard, path: "/overview", roles: [1] },

//   // MAIN DASHBOARD
//   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] },

//       {
//       id: "master",
//       label: "Master",
//       icon: Layers,
//       roles: [1],
//       children: [
//         { id: "categories", label: "Category", path: "/categories", icon: Layers },
//         { id: "brands", label: "Brand", path: "/brands", icon: Layers },
//         { id: "devicemodal", label: "Device Models", path: "/devicemodal", icon: Layers },
//         { id: "products", label: "Products", path: "/products", icon: Layers },
//         { id: "pricetemplate", label: "Price Templates", path: "/pricetemplate", icon: BookTemplate },
//         { id: "badgepackage", label: "Badges & Packages", path: "/badgepackage", icon: BadgeCheck },
//       ]
//     },

//     // {
//     //   id: "partner",
//     //   label: "Partner",
//     //   icon: Layers,
//     //   roles: [1],
//     //   path: "/partners",
//     //   children: [
//     //     { id: "amdcomp", label: "Master Channel Partner (MCP)", path: "/amdcomp", icon: UsersRound, },
//     //     { id: "admagents", label: "Channel Partner (CP)", path: "/admagents", icon: UsersRound, },
//     //     { id: "admretailers", label: "Retailers", path: "/admretailers", icon: Store },
//     //     { id: "admretuser", label: "ARP Users", path: "/admretuser", icon: UserCog },
//     //     { id: "customerlist", label: "Customer List", path: "/customerlist", icon: ClipboardList },
//     //   ]
//     // },

//     { id: "partner", label: "Partners", icon: User2Icon, path: "/partners", roles: [1] },
//     {
//       id: "transactions",
//       label: "Invoices & Payments",
//       icon: IndianRupee,
//       roles: [1],
//       children: [
//         { id: "keys", label: "Payment ID's", path: "/keys", icon: KeySquare, },
//         { id: "paymentlist", label: "Payment List", path: "/paymentlist", icon: IndianRupeeIcon },
//         { id: "retinv", label: "Invoices & Payment", path: "/retinv", icon: ReceiptIndianRupee },
//       ]
//     },
//     {
//       id: "commandearnings",
//       label: "Commissions & Earnings",
//       icon: IndianRupee,
//       roles: [1],
//       children: [
//         { id: "earnings", label: "Earnings", path: "/earnings", icon: ChartLine, },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//     {
//       id: "warranty",
//       label: "Warranty Mitra",
//       icon: IndianRupee,
//       path: "/agentdashboard",
//       roles: [4],
//       children: [
//         { id: "agentretailers", label: "ARP & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
//         { id: "empdash", label: "Lead", icon: Briefcase, path: "/empdashboard", roles: [4] },
//         { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,4,5] },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//     {
//       id: "locker",
//       label: "EMI Locker",
//       icon: IndianRupee,
//       path: "/lockerdashboard",
//       roles: [4],
//       children: [
//         { id: "lockerallretailers", label: "Retailers", path: "/lockerallretailers", icon: Users, },
//         { id: "lockerkeys", label: "Keys", path: "/lockerkeys", icon: KeyRound, },
//         { id: "lockerinventory", label: "Inventory", path: "/lockerinventory", icon: Package, },
//         { id: "lockerorders", label: "Orders", path: "/lockerorders", icon: Package, },
//         { id: "lockerinvoices", label: "Invoices", path: "/lockerinvoices", icon: Package, },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//   // ADMIN DASHBOARD
//   // { id: "amdcomp", label: "Master Channel Partner (MCP)", icon: UsersRound, path: "/amdcomp", roles: [2] },
//   { id: "admagents", label: "Channel Partner (CP)", icon: UsersRound, path: "/admagents", roles: [2] },
  
//   { id: "allemployees", label: "Employees", icon: UserPlus, path: "/allemployees", roles:[1] },
//   // { id: "admretailers", label: "Retailers", icon: Store, path: "/admretailers", roles: [1] },
//   // { id: "keys", label: "Payment ID's", icon: KeySquare, path: "/keys", roles: [1] },
//   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1] },
//   // { id: "admcomsn", label: "Commissions & Payouts", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [1] },
//   // { id: "admtask", label: "Tasks & Work", icon: ClipboardType, path: "/admtask", roles: [1,2] },
//   { id: "admlegal", label: "Legal & Compliance", icon: FileSignature, path: "/admlegal", roles: [1,2] },
//   // { id: "admretuser", label: "ARP Users", icon: UserCog, path: "/admretuser", roles: [1] },
//   // { id: "admanltc", label: "Analytics & Targets", icon: ChartLine, path: "/admanltc", roles: [1,2] },
//   // { id: "devicemodal", label: "Device Model", icon: PackageCheck, path: "/devicemodal", roles: [1] },
//   { id: "assignmap", label: "Assign Map", icon: MapIcon, path: "/assignmap", roles: [1] },
//   // { id: "paymentlist", label: "Payment List", icon: IndianRupeeIcon, path: "/paymentlist", roles: [1] },
  
//   // { id: "payment-details", label: "Payment List", icon: IndianRupeeIcon, path: "/company/payment-details/:paymentId", roles: [1,2] },

//   // EMPLOYEE DASHBOARD
//   { id: "empdash", label: "Dashboard", icon: Briefcase, path: "/empdashboard", roles: [1,2,3] },
//   { id: "teammember", label: "Team Members", icon: Users, path: "/teammember", roles: [1,3] },
//   // { id: "badgepackage", label: "Badges & Packages", icon: BadgeCheck, path: "/badgepackage", roles: [1] },

//   // OPERATION DASHBOARD
//   { id: "oprdash", label: "Dashboard", icon: FolderKanban, path: "/oprdashboard", roles: [3] },
//   { id: "oprret", label: "Users", icon: Store, path: "/oprretail", roles: [3] },
//   // { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
//   { id: "oprreports", label: "Reports", icon: FileSpreadsheet, path: "/oprreports", roles: [3] },

//   // AGENT DASHBOARD
//   // { id: "agentdashboard", label: "Dashboard", icon: Layers, path: "/agentdashboard", roles: [4] },
  
//   // { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

//   // RETAILER DASHBOARD
//   { id: "retailerdashboard", label: "Home", icon: PieChart, path: "/retailerdashboard", roles: [5] },
//   { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5,6] },
//   { id: "customerlist", label: "Customer List", icon: ClipboardList, path: "/customerlist", roles: [5,6] },
//   { id: "earnings", label: "Earnings", icon: ChartLine, path: "/earnings", roles: [2,5,6] },
//   // { id: "admcomsn", label: "Commissions", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [2,4,6] },
//   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5] },
//   { id: "retproduct", label: "Subscription Products", icon: LucideIdCardLanyard, path: "/retproduct", roles: [5] },
//   { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,5] },
//   // { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
//   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
//   { id: "activation-report", label: "Activation Reports", icon: Activity, path: "/activation-report", roles: [2,5] },
//   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },
 
//   // USER DASHBOARD
//   { id: "userdashboard", label: "Dashboard", icon: Target, path: "/userdashboard", roles: [6] },
//   // { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
//   // { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
//   { id: "userprofile", label: "Profile", icon: UserCircle, path: "/userprofile", roles: [6] },

//   // CUSTOMER DASHBOARD
//   { id: "custdashboard", label: "Dashboard", icon: PieChart, path: "/custdashboard", roles: [7] },
//   { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [7] },
//   { id: "custclaims", label: "Claims", icon: ClipboardCheck, path: "/custclaims", roles: [7] },
//   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [7] },
//   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [7] },

//   { id: "report-logs", label: "Message Logs", icon: Logs, path: "/report-logs", roles: [1] },

//   // locker 

//   // { id: "locker", label: "Locker", icon: Logs, path: "/locker", roles: [4] },
  
// ];

// export default navBarData;

